<template>

  <v-container>
    <v-row align="center" justify="center">
      <v-col>
        <v-card-title class="card-title">

        </v-card-title>

        <ActivityForm/>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>


export default {
  data () {
    return {}
  },
  components: {},
  methods: {}

}
</script>

<style scoped>


</style>
